/* eslint-disable no-restricted-syntax, no-continue */
import qs from 'qs';
import { INDEX_PRODUCTS } from 'src/lib/algolia';

const SearchMin = {
  F: 'filters',
  HM: 'hierarchicalMenu',
  Q: 'query',
  RL: 'refinementList',
  filters: 'F',
  hierarchicalMenu: 'HM',
  query: 'Q',
  refinementList: 'RL',
};
/**
 * @todo: review the logic
 */
export const parseQueryParams = () => {
  const paramsMin = qs.parse(window.location.search, { ignoreQueryPrefix: true }) || {};
  const params = {};
  // De-minify object props
  const paramProps = Object.keys(paramsMin);
  for (const prop of paramProps) {
    const key = SearchMin[prop] || prop;
    params[key] = paramsMin[prop];
    // Convert string booleans to boolean
    if (key === 'toggle') {
      params[key] = {}; // clear toggle params
      const toggleKeys = Object.keys(paramsMin[prop]);
      for (const toggleKey of toggleKeys) {
        params[key][toggleKey] = JSON.parse(paramsMin[prop][toggleKey]); // parse boolean string
      }
    }
    if (key === 'sortBy') {
      params[key] = paramsMin[prop].includes(INDEX_PRODUCTS) ? paramsMin[prop] : `${INDEX_PRODUCTS}_${paramsMin[prop]}`;
    }
  }
  params.query = params.Q || params.q || params.query || '';
  return params;
};
/**
 * @todo review the logic
 * @param {object} searchState
 * @param {boolean} lockPagination
 * @returns {string}
 */
export const searchStateToUrl = (searchState, lockPagination = false) => {
  const searchProps = Object.keys(searchState);
  const state = {};
  for (const prop of searchProps) {
    const value = searchState[prop];
    if (prop === 'sortBy') {
      state[prop] = value.replace(`${INDEX_PRODUCTS}_`, '');
      continue;
    }
    // Drop page info as we are doing infinite scroll
    if (prop === 'page') {
      const paramsMin = qs.parse(window.location.search, { ignoreQueryPrefix: true }) || {};
      const pageNumber = Number(paramsMin.page) || 1;
      state[prop] = lockPagination ? pageNumber + 1 : value;
      continue;
    }
    // Drop configure
    if (prop === 'configure') {
      continue;
    }
    // Omit empty facet
    if (prop === 'hierarchicalMenu' && value) {
      if (!value['menu.categories']) {
        continue;
      }
    }
    // Omit default inStock state
    if (prop === 'toggle' && value && value.inStock) {
      continue;
    }
    // Omit empty refinement list keys
    if (prop === 'refinementList' && value) {
      for (const valueKey of Object.keys(value)) {
        if (!value[valueKey]) {
          delete value[valueKey];
        }
      }
    }
    // Omit empty query/Q key
    if (prop === 'query' && !value) {
      continue;
    }
    // Map properties to minified keys
    const key = SearchMin[prop] || prop;
    // Omit 'query' param specifically, as prop Q should take precedence
    if (key === 'query') {
      continue;
    }
    state[key] = value;
  }
  return `${window.location.pathname}?${qs.stringify(state, { encodeValuesOnly: true })}`;
};
/**
 * return link params to algolia collection tracking filters
 * @param {string} linkParams link params like RL[sizes][0]=6.5&RL[sizes][1]=7&RL[sizes][2]=7.5
 * @returns {string} algolia collection tracking filters like [sizes:6.5, sizes:7]
 */
export const linkParamsToFilters = (linkParams) => linkParams?.split('&').reduce((acc, param) => {
  const [key, value] = decodeURIComponent(param).split('=');
  const facetMatch = /\[\D+]/g.exec(key);
  return facetMatch
    ? [...acc, `${facetMatch[0].replaceAll(/[[\]]/g, '')}:${value}`]
    : acc;
}, []);

/**
 * return indicates the presence of multiple facets.
 * @param url
 * @returns {*|boolean}
 */
export const hasMultipleFacets = (url) => {
  const matches = url?.match(new RegExp('\\\\[.+\\\\]', 'g'));
  return matches && matches.length > 1;
};
